import { useState } from 'react'
import { Popover, PopoverBody } from 'reactstrap'
import { abbrNum } from '../../utility/helperFunctions'
import PropTypes from 'prop-types'

// ASSETS
import styles from './Claps.module.scss'
import ActiveClap from '../../assets/images/op36/clap_secondary.png'

const Claps = ({ likes, currentUser }) => {
  const [clapHoverTriggered, setClapHoverTriggered] = useState(false)
  const likesCount = likes.length

  return (
    <>
      <div
        id='Claps'
        className={styles.claps}
        onMouseEnter={() => setClapHoverTriggered(true)}
        onMouseLeave={() => setClapHoverTriggered(false)}
      >
        <div className={styles.clapsWrapper}>
          <img src={ActiveClap} alt='Activity Clap' />
        </div>

        <p>{abbrNum(likesCount, 1)}</p>
      </div>
      {likesCount > 0 && (
        <Popover style={{ zIndex: 9999 }}
          placement='bottom'
          isOpen={clapHoverTriggered}
          target={'Claps'}
          toggle={() => setClapHoverTriggered(true)}
        >
          <PopoverBody className={'p-2'}>
            {likes.map(like => (
              <p className='mb-0' key={like.id}>
                {currentUser.id === like.user.id
                  ? 'You'
                  : `${like.user.first_name} ${like.user.last_name}`}
              </p>
            ))}
            {likesCount > 10 && (
              <p>+ {likesCount - 10} more</p>
            )}
          </PopoverBody>
        </Popover>
      )}
    </>
  )
}

Claps.propTypes = {
  likes: PropTypes.array,
  currentUser: PropTypes.shape({
    id: PropTypes.number,
  }),
}

export default Claps
